import {
  Box,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import { useNavigate } from "react-router-dom";
import React from "react";

export default function TopBar({ handleDrawerToggle, pageName, showBackIcon }) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Box
      position="fixed"
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        color: "#000",
        boxShadow: "none",
        borderBottom: "1px solid #e0e0e0",
        zIndex: 1201,
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { md: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        {showBackIcon && (
          <IconButton onClick={handleGoBack} sx={{ mr: 2 }}>
            <FirstPageIcon sx={{ fontSize: 30 }} />
          </IconButton>
        )}

        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
          {pageName}
        </Typography>
      </Toolbar>
    </Box>
  );
}
